module.exports = __webpack_public_path__ + "static/img/global-login-bg.424edb7.png";